module.exports = __webpack_public_path__ + "img/swiper_02.f1b4bc18.jpg";